__turbopack_context__.v({
  "facets": "facets-component-module-scss-module__Nx_c0a__facets",
  "facets__container": "facets-component-module-scss-module__Nx_c0a__facets__container",
  "facets__facet-selectors": "facets-component-module-scss-module__Nx_c0a__facets__facet-selectors",
  "facets__facets-container": "facets-component-module-scss-module__Nx_c0a__facets__facets-container",
});
